import { Box, Spacer, TextInput } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/core'
import * as React from 'react'
import { useEffect } from 'react'
import { AepsButton } from '../../comps/AepsButton'
import { Container } from '../../comps/Container'
import { Title } from '../../comps/Title'
import { useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'

export const EnterMobileNoScreen = () => {
  const [mobileNo, onMobileNoChanged] = React.useState('')
  const navigation = useNavigation()
  const { sendOTPToCustomerMobile } = useStores((root) => ({
    sendOTPToCustomerMobile: root.customer.sendOTPToCustomerMobile,
  }))
  const [isLoading, setIsLoading] = React.useState(false)

  const route: any = useRoute()
  React.useEffect(() => {
    navigation.setOptions({ headerTitle: 'Link Aadhar' })
  }, [navigation])

  useEffect(() => {
    onMobileNoChanged(route?.params?.mobileNo)
  }, [route])
  // const [sendOTPToCustomerMobileApi, sendOtpHandler] = useLazyApiData(sendOTPToCustomerMobile)
  const onSubmit = async () => {
    setIsLoading(true)
    const res = await sendOTPToCustomerMobile(mobileNo)
    setIsLoading(false)
    if (res?.status === 'SUCCESS') {
      navigation.navigate(Screens.ENTER_CUSTOMER_MOBILE_OTP as never, { mobileNo, ...route?.params } as never)
    }
  }

  /*useEffect(() => {
    if (sendOtpHandler.state == 'fulfilled') {
      alert('n')


    }
  }, [mobileNo, navigation, route, sendOtpHandler])*/

  return (
    <Container showFooter={true}>
      <Title title="Enter Customer Registered Mobile number" />
      <Spacer size={42} />
      <Box flex={1}>
        <TextInput
          fontSize={24}
          testID="mobile-account-no-input"
          placeholder="Mobile number"
          textAlign={'center'}
          color={'PRIMARY_STORNG'}
          bottomLineColor={'PRIMARY_STORNG'}
          maxLength={10}
          placeholderTextColor="BRAND_PRIMARY_WHITE"
          value={mobileNo}
          onChangeText={(text) => {
            text = text.replace(/[^0-9]/g, '')
            onMobileNoChanged(text)
          }}
          keyboardType="numeric"
          error={''}
          touched={true}
          errorTextVerticalSpacing={8}
          errorTextAlign="center"
          errorTextFontWeight={'BOLD'}
        />
      </Box>
      <AepsButton title={'Generate OTP'} onPress={onSubmit} disabled={mobileNo?.length !== 10} isLoading={isLoading} />
    </Container>
  )
}
